import { Area } from "@/lib/types/area";
import { TimelapseStatus as TimelapseStatusEnum } from "@/lib/types/timelapse";
import { Button } from "@mantine/core";
import { TimelapseStatus } from "../timelapse/TimelapseStatus";
import { LoadableImage } from "../atoms/LoadableImage";
import { FaLink } from "react-icons/fa6";
import { useNavigate } from "@tanstack/react-router";
import { CardGray } from "../atoms/CardGray";

type Props = {
  area: Area;
  idx: number;
  onTimelapseCreate: (area: Area) => void
  onTimelapseUpdate: (area: Area, status: TimelapseStatusEnum) => void;
  onTimelapseDelete: (area: Area) => void;
}

export const ScannerArea = ({ area, idx, onTimelapseCreate, onTimelapseUpdate, onTimelapseDelete }: Props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (!area.timelapse) return

    navigate({ to: "/timelapses/$id", params: { id: area.timelapse.id.toString() } })
  }

  return (
    <>
      <CardGray className="flex flex-col gap-4 border-dashed">
        <div className="flex items-center justify-between">
          <span className="font-semibold">{`Area ${idx + 1}`}</span>
          {area.timelapse && <TimelapseStatus variant="outline" status={area.timelapse.status} />}
        </div>
        {area.timelapse ? (
          <div className="flex flex-col gap-2">
            <div>
              <div className="ml-4 mb-2 md:ml-8 md:mb-8 h-36 aspect-square float-right rounded-2xl overflow-hidden">
                {area.timelapse.coverId
                  ? <LoadableImage src={`/api/scan/${area.timelapse.coverId}`} />
                  : <div className="w-full h-full flex justify-center items-center text-sm text-muted border border-gray-100 rounded-2xl">No cover yet</div>
                }
              </div>
              <div onClick={handleClick} className="flex items-center gap-2 mb-2 cursor-pointer w-fit">
                {area.timelapse.name}
                <FaLink />
              </div>
              <div className="text-sm text-muted whitespace-pre-wrap">{area.timelapse.description}</div>
            </div>
          </div>
        ) : (
          <div className="min-h-36 flex justify-center items-center">
            <span>No timelapse</span>
          </div>
        )}
        <div className="flex items-center gap-2 justify-end">
          <Button onClick={() => onTimelapseCreate(area)}>New</Button>
          {area.timelapse && (
            <>
              <Button onClick={() => onTimelapseUpdate(area, area.timelapse?.status === TimelapseStatusEnum.STARTED ? TimelapseStatusEnum.PAUSED : TimelapseStatusEnum.STARTED)} variant="outline" color="orange">
                {area.timelapse.status === TimelapseStatusEnum.STARTED ? "Pause" : "Resume"}
              </Button>
              <Button onClick={() => onTimelapseDelete(area)} color="red">Stop</Button>
            </>
          )}
        </div>
      </CardGray>
    </>
  )
}
